import axios from 'axios';

let url = "https://api.gryb.appandwebstudio.com.br";

if (window.location.hostname === 'localhost') {
   url = 'http://localhost:8000';
}

const instance = axios.create({
  baseURL: url
});

// Interceptor para lidar com erros
instance.interceptors.response.use(
  response => response, // Retorna a resposta normalmente se não houver erro
  error => {
    if (error.response && (error.response.status === 400 || error.response.status === 401)) {
      // Redireciona para a URL de login dependendo do ambiente
      localStorage.removeItem('tokenStorage');
      if (window.location.hostname === "localhost") {
        window.location.href = "http://localhost:3000/entrar";
      } else {
        window.location.href = "https://gryb.appandwebstudio.com.br/entrar";
      }
    }
    // Rejeita a Promise com o erro para que outros manipuladores possam usá-la, se necessário
    return Promise.reject(error);
  }
);

export default instance;